import { Link } from "react-router-dom";
import { useSiteFeatures } from "../../hooks/useSiteFeatures";
import {
  useBjelinTranslations,
  useProductTranslations
} from "../../hooks/TranslationHooks";
import { encodeFilterQstring } from "../../utils/ProductsUtils";
import find from "lodash/find";
import Icon from "../Icon";
import PagePreview from "../PagePreview";
import IconMenuItem from "./IconMenuItem";
import {
  productCategoryTitle,
  productCategoryUrl
} from "../../utils/ProductCategoryUtils";
import { useProductCategories } from "../../hooks/ProductCategoryHooks";
import { Asset } from "../../types/Asset";

type CategoryType = {
  category: string;
  image: Asset;
  shopLinks: { field: string; value: string }[];
};

const ProductsMenu = ({
  config
}: {
  config: { categories: CategoryType[] };
}) => {
  const t = useBjelinTranslations();
  const tp = useProductTranslations();
  const features = useSiteFeatures();
  const categories = useProductCategories();

  const mainCategories = config?.categories;

  return mainCategories ? (
    <div className="main-cats">
      {mainCategories.map(mcat => {
        const category = find(categories, { name: mcat.category });
        if (!category) return null;
        const categoryUrl = productCategoryUrl(category);
        const title = productCategoryTitle(category, tp);
        return (
          <div className="main-cat-item" key={mcat.category}>
            <PagePreview
              title={title}
              image={mcat.image}
              //TODO will only work for some categories that have matching pages...
              path={"/" + (category?.path || "")}
              tagLine={tp("category-tagline." + mcat.category)}
            />
            <div className="icon-list">
              <h3>
                <Link to={categoryUrl || ""}>
                  {t(features.shop() ? "buy" : "browse")} {title}
                </Link>
              </h3>
              <ul>
                {mcat.shopLinks.map(l => (
                  <li key={l.field + "-" + l.value}>
                    <Link
                      to={
                        categoryUrl +
                        "?filter=" +
                        encodeFilterQstring({ [l.field]: [l.value] })
                      }
                    >
                      <IconMenuItem {...l} />
                    </Link>
                  </li>
                ))}
              </ul>
              <div>
                <Link to={categoryUrl || ""}>
                  {t("see.all")} {title}{" "}
                  <Icon name="chevron-right" className="ms-1" />
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  ) : (
    <div className="empty-msg">
      <div>
        <Icon name="face-sad-tear" size="4x" />
      </div>
      <div>{t("error.general.short")}</div>
    </div>
  );
};

export default ProductsMenu;
